import { HttpErrorResponse } from '@angular/common/http';

const NO_CONNECTION = 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
const NOT_ALLOWED = 'Seu usuário não tem permissão para esta operação.';
const NOT_FOUND = 'O registro solicitado não foi encontrado.';
const REJECTED = 'A operação foi recusada pelas regras do sistema. Confira os dados e a situação do registro antes de tentar novamente.';
const SERVER_ERROR = 'Ocorreu um erro inesperado no servidor. Tente novamente em instantes.';
const GENERIC_FAILURE = 'Ocorreu uma falha ao processar a solicitação. Tente novamente.';

/** What the API answers when the request itself breaks a rule: sending it again as it is fails the same way. */
const REJECTED_STATUSES: readonly number[] = [400, 409, 422];

/**
 * Why a request failed, as one sentence for the screen. The screen says what it was doing
 * ("Não foi possível carregar os pagamentos.") and adds this; the details are in the console.
 * Takes `unknown` because a resource reports its failure as `Error | undefined`.
 */
export function httpErrorReason(error: unknown): string {
    if (!(error instanceof HttpErrorResponse)) {
        return GENERIC_FAILURE;
    }

    if (error.status === 0) {
        return NO_CONNECTION;
    }

    if (error.status === 403) {
        return NOT_ALLOWED;
    }

    if (error.status === 404) {
        return NOT_FOUND;
    }

    if (REJECTED_STATUSES.includes(error.status)) {
        return REJECTED;
    }

    if (error.status >= 500 && error.status < 600) {
        return SERVER_ERROR;
    }

    return GENERIC_FAILURE;
}
